// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"55cf4109","641":"585b7591","711":"0994ea1b","787":"271d2522","941":"e8e62024"}[chunkId] + ".chunk.js";
};